<div class="logo-bar">
  <div class="intrack-logo"></div>
  <button mat-icon-button (click)="appFacade.toggleFullscreenMode()">
    <ui-svg-icon
      class="tw-mr-0"
      [name]="(appFacade.fullscreenMode$ | async) ? iconNameList.FullscreenExit : iconNameList.Fullscreen"
    ></ui-svg-icon>
  </button>
</div>
<ul class="menu">
  @for (menuElement of (filteredMenuStructure$ | async); track menuElement.title) {
  <li *show="menuElement.permission" class="menu-group tw-flex">
    @if (!menuElement.children) {
    <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: menuElement, icon: true }"></ng-container>
    } @else {
    <mat-expansion-panel
      #expansionPanel
      class="menu-group"
      hideToggle
      [expanded]="
        activeMenuItem$.value !== menuNavigation$.value
          ? menuElement.title === menuNavigation$.value
          : menuElement.title === activeMenuItem$.value
      "
      (click)="menuNavigation$.next(menuElement.title)"
    >
      <mat-expansion-panel-header matRipple [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
        <ng-container
          *ngTemplateOutlet="
            expansionPanelHeaderItem;
            context: {
              $implicit: menuElement,
              expansionPanel: expansionPanel,
              subPanelItem: false
            }
          "
        ></ng-container>
      </mat-expansion-panel-header>

      @if (menuElement.children?.length > 0) {
      <ul>
        @for (child of menuElement.children; track child.title) {
        <li *show="child.permission">
          @if (!child.children) {
          <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: child }"></ng-container>
          } @else {
          <mat-accordion>
            <mat-expansion-panel
              #expansionPanel
              class="menu-group"
              hideToggle
              [expanded]="child.title === subPanelNavigation$.value"
              (click)="subPanelNavigation$.next(child.title); $event.stopPropagation()"
            >
              <mat-expansion-panel-header matRipple [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
                <ng-container
                  *ngTemplateOutlet="
                    expansionPanelHeaderItem;
                    context: {
                      $implicit: child,
                      expansionPanel: expansionPanel,
                      subPanelItem: !!child.url
                    }
                  "
                ></ng-container>
              </mat-expansion-panel-header>

              @if (child.children) {
              <ul>
                @for (item of child.children; track item.title) {
                <li class="low-level-item">
                  <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
                </li>
                }
              </ul>
              }
            </mat-expansion-panel>
          </mat-accordion>
          }
        </li>
        }
      </ul>
      }
    </mat-expansion-panel>
    }
  </li>
  }
</ul>

<ng-template #itemTemplate let-item let-icon="icon">
  <ng-container *show="item.permission">
    @if (item.url) {
    <a
      class="menu-item menu-item--sub"
      [routerLink]="item.url"
      [routerLinkActive]="item.url ? 'active' : ''"
      [routerLinkActiveOptions]="{ exact: true }"
      mat-menu-item
    >
      @if (icon) {
      <ui-svg-icon class="tw-self-center" [name]="item.icon"></ui-svg-icon>
      }
      {{ item.title | translate }}
    </a>
    } @else if (item.externalUrl) {
    <a class="menu-item menu-item--sub" [href]="item.externalUrl" target="_blank" mat-menu-item>
      @if (icon) {
      <ui-svg-icon class="tw-self-center" [name]="item.icon"></ui-svg-icon>
      }
      {{ item.title | translate }}
    </a>
    }
  </ng-container>
</ng-template>

<ng-template #expansionPanelHeaderItem let-item let-expansionPanel="expansionPanel" let-subPanelItem="subPanelItem">
  <div class="menu-item-group tw-flex tw-justify-between">
    @if (!subPanelItem) {
    <a class="menu-item__link" [ngClass]="{ 'tw-pl-[46px]': !item.icon }">
      @if (item.icon) {
      <ui-svg-icon class="tw-self-center" [name]="item.icon"></ui-svg-icon>
      }
      {{ item.title | translate }}
    </a>
    } @else {
    <a
      class="menu-item__link"
      [class.menu-item__subitem]="subPanelItem"
      [routerLink]="item.url"
      [routerLinkActive]="item.url ? 'active' : ''"
      (click)="subPanelNavigation$.next(''); $event.stopPropagation()"
      mat-menu-item
    >
      {{ item.title | translate }}
    </a>
    } @if (item.children?.length) {
    <ui-svg-icon
      class="dropdown-icon tw-self-center"
      [width]="18"
      [name]="expansionPanel.expanded ? iconNameList.Up : iconNameList.Down"
    ></ui-svg-icon>
    }
  </div>
</ng-template>
